import React from 'react'

interface Props {
  /** Setzt die Bühne zurück (Tabs leeren + persistierten Zustand löschen). */
  onReset: () => void
  children: React.ReactNode
}

interface State {
  hasError: boolean
}

/**
 * Fängt Render-Fehler der Bühne ab, damit eine fehlerhafte Auswertung
 * (z.B. ein ungültiger render_panel-Block aus der Agent-Antwort) nicht die
 * gesamte App aushängt ("weißer Bildschirm"). Die Chat-Antwort bleibt
 * unberührt; der Nutzer kann die Bühne zurücksetzen.
 *
 * Wird per `key` (aktiver Tab) neu gemountet — eine nachfolgende gültige
 * Auswertung wird damit automatisch wieder dargestellt.
 */
export default class StageErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: unknown) {
    // eslint-disable-next-line no-console
    console.error('Bühnen-Render fehlgeschlagen:', error)
  }

  handleReset = () => {
    this.setState({ hasError: false })
    this.props.onReset()
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div className="k-stage" data-screen-label="Bühne: Fehler">
        <div className="k-stage__inner">
          <div className="k-frame">
            <div className="k-frame__head">
              <div className="k-frame__label">
                <span className="num">!!</span>
                <span>/ Fehler</span>
              </div>
              <h2 className="k-frame__title">Auswertung konnte nicht dargestellt werden</h2>
            </div>
            <div className="k-frame__body">
              <p>
                Die strukturierte Auswertung enthielt ein ungültiges Element und
                konnte nicht angezeigt werden. Ihre Chat-Antwort bleibt davon
                unberührt.
              </p>
            </div>
            <div className="k-frame__actions">
              <button className="k-btn k-btn--ghost" onClick={this.handleReset}>
                Bühne zurücksetzen <span className="arr">→</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
